import React from 'react'
import { Button, Popover, TextField, Link, Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'


/* styles that will be passed to the Login component */
const styles = theme => ({

    /* style for text boxes on the popup */
    textField: {
        margin: theme.spacing.unit,
        width: 300
    },

    /* style for the anchor "Forgot password" */
    forgotPasswordLink: {
        float: 'right',
        margin: theme.spacing.unit
    },

    /* style for login button */
    buttonLogin: {
        width: '90%',
        float: 'center',
        margin: theme.spacing.unit
    },

    /* simple style with common properties */
    defaultControl: {
        margin: theme.spacing.unit
    }
})

/* Component that implements button "Login" (on the app bar)
and the popup with fields for typing login info */
class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            email: '',
            password: '',
            keepLoggedIn: false,
        }
        this.passwordInputRef = React.createRef();
    }

    /* Opens popup after pressing on Login button on the app bar  */
    appBarButtonClick = event => {
        this.setState({
            anchorEl: event.currentTarget,
        })
    }

    // handles password field key press
    handlePasswordOnKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.onLogInButtonClick();
        }
    }

    // handles email field key press
    handleEmailOnKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.passwordInputRef.current.focus();
        }
    }

    /* Hides popup */
    popupClosed = () => {
        this.setState({
            anchorEl: null,
        })
    }

    onLogInButtonClick = () => this.props.onLogInClick(
        this.state.email,
        this.state.password,
        this.state.keepLoggedIn
    )

    render() {
        const { classes } = this.props
        const { anchorEl } = this.state
        const open = Boolean(anchorEl)

        return (
            <div>
                <Button
                    aria-owns={open ? 'simple-popper' : undefined}
                    aria-haspopup='true'
                    variant='contained'
                    onClick={this.appBarButtonClick}
                >
                    {this.props.t('TopBar:log in')}
                </Button>
                <Popover
                    id='simple-popper'
                    open={open}
                    anchorEl={anchorEl}
                    onClose={this.popupClosed}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    {
                        this.props.isLogInPending
                            ? ( // if Login request is pending -- display loading view
                            <Typography variant='overline' className={classes.notification}>
                                { this.props.t('TopBar:loading') }
                            </Typography>
                            )
                            : ( // if Login is not pending -- display the login form
                                <>
                                    {this.props.loginError ? (
                                        <Typography variant='overline' className={classes.notification}>
                                            { this.props.t(`TopBar:${this.props.loginError}`) }
                                        </Typography>
                                    ) : undefined}


                                    { /* Text box for typing the email */}
                                    < div >
                                        <TextField
                                            id="outlined-email-input"
                                            label={this.props.t('TopBar:email')}
                                            className={classes.textField}
                                            type="email"
                                            name="email"
                                            autoComplete="email"
                                            margin="normal"
                                            variant="outlined"
                                            floatingLabelStyle={classes.resize}
                                            value={this.state.email}
                                            onKeyPress={this.handleEmailOnKeyPress}
                                            onChange={(event) => {this.setState({...this.state, email: event.target.value})}}
                                        />
                                    </div>

                                    <div>
                                        <TextField
                                            id="outlined-password-input"
                                            label={this.props.t('TopBar:password')}
                                            inputRef={this.passwordInputRef}
                                            className={classes.textField}
                                            type="password"
                                            autoComplete="current-password"
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                classes: {
                                                    input: classes.resize
                                                }
                                            }}
                                            value={this.state.password}
                                            onKeyPress={this.handlePasswordOnKeyPress}
                                            focused={this.state.passwordFocus}
                                            onChange={(event) => {this.setState({...this.state, password: event.target.value})}}
                                        />
                                    </div>

                                    <div>
                                        <Link className={classes.forgotPasswordLink}>
                                            {this.props.t('TopBar:forgot password')}
                                        </Link>
                                    </div>

                                    <div>
                                        <Button variant="contained" color="primary" className={classes.buttonLogin}
                                            onClick={this.onLogInButtonClick}>
                                            {this.props.t('TopBar:log in')}
                                        </Button>
                                    </div>

                                    <div>
                                        <FormControlLabel className={classes.defaultControl}
                                            control={<Checkbox 
                                                value={this.state.keepLoggedIn}
                                                onChange={(event) => {this.setState({...this.state, keepLoggedIn: !this.state.keepLoggedIn})}}
                                            />}
                                            label={this.props.t('TopBar:stay on site')} />
                                    </div>
                                </>
                            )}
                </Popover>
            </div>
        )
    }
}

export default withTranslation()(withStyles(styles)(Login))
